import { BMPrimitives } from "@traveloka/district-bloom";
import { useCallback, useState } from "react";
import { ViewStyle } from "react-native";

type Params = {
  width: ViewStyle["width"];
};

export default function useSpotlightCardWidth({ width }: Params) {
  const [measuredWidth, setMeasuredWidth] = useState<number | undefined>(
    undefined
  );

  const isNumericWidth = typeof width === "number";
  const itemWidth = isNumericWidth
    ? width - 2 * BMPrimitives.BMSize.xl
    : measuredWidth;

  const handleMeasureWidth = useCallback((newWidth: number) => {
    setMeasuredWidth(newWidth);
  }, []);

  return {
    itemWidth,
    onMeasureWidth: handleMeasureWidth,
  };
}
